











































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import AccountGeneralDepositValuesRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/GeneralDeposit/AccountGeneralDepositValuesRead.vue';
import AccountDepositFixedTermValuesRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/FixedTerm/AccountDepositFixedTermValuesRead.vue';
import AccountDepositFixedTermMaturityValuesRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/FixedTermMaturity/AccountDepositFixedTermMaturityValuesRead.vue';
import AccountDepositCoolingOffValuesRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/CoolingOff/AccountDepositCoolingOffValuesRead.vue';

@Component({ name: 'DefaultWalletSettings', components: { AccountGeneralDepositValuesRead, AccountDepositFixedTermValuesRead, AccountDepositFixedTermMaturityValuesRead, AccountDepositCoolingOffValuesRead } })
export default class extends SaascadaVue {

    tabIndex = 0;

    get values() {
        return DepositAccountModule.depositAccount.accountValues;
    }

}
